import { createStateMetaMap } from '@/utils/state';

export enum RoleCode {
  Owner = 'Owner',
  Admin = 'Admin',
  Employee = 'Employee',
  CardManager = 'CardManager',
  Viewer = 'Viewer',
}

const roleOptions: StateOption<RoleCode, RoleCode>[] = [
  { value: RoleCode.Owner, code: RoleCode.Owner, label: 'Owner', color: '#9A6700', bgLight: '#FFF7DF', border: 'transparent', darkColor: '#FFD166', bgDark: '#3B3017', borderDark: 'transparent' },
  { value: RoleCode.Admin, code: RoleCode.Admin, label: 'Admin', color: '#087C75', bgLight: '#E5F8F5', border: 'transparent', darkColor: '#5DE8D9', bgDark: '#123B37', borderDark: 'transparent' },
  { value: RoleCode.Employee, code: RoleCode.Employee, label: 'Employee', color: '#2563EB', bgLight: '#EAF2FF', border: 'transparent', darkColor: '#93C5FD', bgDark: '#203451', borderDark: 'transparent' },
  { value: RoleCode.CardManager, code: RoleCode.CardManager, label: 'Card Manager', color: '#7C3AED', bgLight: '#F3ECFF', border: 'transparent', darkColor: '#C4A4FF', bgDark: '#30204B', borderDark: 'transparent' },
  { value: RoleCode.Viewer, code: RoleCode.Viewer, label: 'Viewer', color: '#667085', bgLight: '#F1F3F5', border: 'transparent', darkColor: '#C9CED6', bgDark: '#2A2A2A', borderDark: 'transparent' },
];

export const roleMetaMap = createStateMetaMap(roleOptions);

export function resolveRole(role?: string | null): ApiState<RoleCode> | null {
  const normalized = (role ?? '').trim().toLowerCase().replace(/[\s_-]+/g, '');
  const match = roleOptions.find((option) => option.code.toLowerCase().replace(/[\s_-]+/g, '') === normalized);
  return match ? { value: match.value, code: match.code } : null;
}
